import clsx from "clsx";
import React from "react";
import { IconSearch } from "@trainline/depot-web";
import * as styles from "./PriceTag.module.css";
const PriceTag = ({
  priceString,
  isEmpty = false,
  isCheapest = false,
  isLoading = false
}) => {
  if (isEmpty) {
    return /* @__PURE__ */ React.createElement("div", {
      "data-testid": "price-tag",
      "aria-busy": "false",
      "aria-hidden": "true",
      className: clsx(styles.priceTag)
    });
  }
  if (isLoading) {
    return /* @__PURE__ */ React.createElement("div", {
      "data-testid": "price-tag",
      "aria-busy": "true",
      className: clsx(styles.priceTag)
    }, /* @__PURE__ */ React.createElement("span", {
      className: clsx(styles.skeleton)
    }, /* @__PURE__ */ React.createElement("span", {
      className: clsx(styles.placeholder)
    })));
  }
  return /* @__PURE__ */ React.createElement("div", {
    "data-testid": "price-tag",
    "aria-busy": "false",
    className: clsx(styles.priceTag, isCheapest && styles.isCheapest)
  }, !priceString ? /* @__PURE__ */ React.createElement("span", {
    className: clsx(styles.icon)
  }, /* @__PURE__ */ React.createElement(IconSearch, null)) : /* @__PURE__ */ React.createElement("div", {
    className: clsx(styles.priceWrapper)
  }, priceString));
};
var PriceTag_default = PriceTag;
export {
  PriceTag_default as default
};
